import { FC, useContext, useMemo, useRef } from "react";
// 组件
import Dragpreview from "./Dragpreview";
import OptionItem from "./OptionItem";
// 方法
import {DragDropContext} from './context/dragDropContext';
// 常量
import { DragDropOption, DragpreviewActionType, OptionsProps } from "./interface";
import { STATUS_CREATED, STATUS_CREATED_CODE } from "../constants/constant";

/** 拖动组 */
const Options: FC<OptionsProps> = props => {
  const { dragItems, isMove, isChangeSize, dropfullScreenRef, } = useContext(DragDropContext);
  const dragpreviewRef = useRef<DragpreviewActionType>();
  const effectiveDragItems: DragDropOption[] = useMemo(() => {
    return dragItems.filter(item => item[STATUS_CREATED_CODE] !== STATUS_CREATED.DELETE);
  }, [dragItems]);
  return (
    <>
      {
        effectiveDragItems?.map(dragItem => {
          return (
            <OptionItem
              previewRef={dragpreviewRef}
              fullScreenRef={dropfullScreenRef}
              key={dragItem.name}
              isMove={isMove}
              isChangeSize={isChangeSize}
              {...dragItem}
            />
          );
        })
      }
      <Dragpreview actionRef={dragpreviewRef} />
    </>
  );
};

export default Options;